var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcMaterialType(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 22.5H3C2.175 22.5 1.5 21.825 1.5 21V12H3V21H21V3H12V1.5H21C21.825 1.5 22.5 2.175 22.5 3V21C22.5 21.825 21.825 22.5 21 22.5ZM16.875 9.075L12.375 6.825C12.15 6.75 11.925 6.75 11.7 6.825L7.2 9.075C6.975 9.225 6.825 9.45 6.75 9.75V15C6.75 15.3 6.9 15.525 7.2 15.675L11.7 17.925C11.925 18 12.15 18 12.375 17.925L16.875 15.675C17.1 15.525 17.25 15.3 17.325 15V9.75C17.325 9.45 17.175 9.225 16.95 9.075H16.875ZM12 8.325L14.85 9.75L12 11.175L9.15 9.75L12 8.325ZM8.25 10.95L11.25 12.45V16.05L8.25 14.55V10.95ZM12.75 16.05V12.45L15.75 10.95V14.55L12.75 16.05ZM0 7.5H3.75V9H0V7.5ZM9 0V3.75H7.5V0H9ZM2.55 1.5L5.175 4.125L4.125 5.175L1.5 2.55L2.55 1.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMaterialType);
export default __webpack_public_path__ + "static/media/ic-material-type.9c4fead99281a70ed3a1e2a1f0a8d822.svg";
export { ForwardRef as ReactComponent };